import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TokenService } from 'projects/login/src/app/services/auth/token.service';
import { RedirectService } from 'projects/login/src/app/services/redirect/redirect.service';
import { Layouts } from './whitelabel/layouts';
import { ThemeService } from './whitelabel/theme.service';

@Component({
  selector: 'pay-login-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  private _themeService = inject(ThemeService);
  private _redirect = inject(RedirectService);

  ngOnInit(): void {
    this.matchThemes();

    if (!TokenService.sessionId && (!document.location.pathname || document.location.pathname === '/')) {
      this._redirect.goToInvalidSession();
    }
  }

  private matchThemes() {
    const url = window.location.hostname;

    const finalLayout = Layouts.find((value) => url.includes(value.url))?.layoutModel;

    this._themeService.setThemeBasedOnLayout(finalLayout);
  }
}
